/** The registry writes this literal when discovery never found an athletics site. */
const PLACEHOLDER_URL = "unknown";

export function isPlaceholderUrl(url: string | null | undefined): boolean {
  const value = (url ?? "").trim();
  return value === "" || value.toLowerCase() === PLACEHOLDER_URL;
}

/** Hostname for display; falls back to the raw value when it does not parse as a URL. */
export function hostnameOf(url: string): string {
  try {
    return new URL(url).hostname || url;
  } catch {
    return url;
  }
}
